export enum Role {
  SituSystemsAdmin = 'Situ Systems Admin',
  SituSystemsDeveloper = 'Situ Systems Developer',
  SituSystemsEmployee = 'Situ Systems Employee',
  AssetCreator = 'Asset Creator',
  BuilderAdmin = 'Builder Admin',
  PartnerAdmin = 'Partner Admin',
  Admin = 'Admin',
  User = 'User',
  ExternalProductContractor = 'ExternalProductContractor',
  CompanyProductPublisher = 'CompanyProductPublisher',
  Release = 'Release',
  ProductCatalog = 'ProductCatalog',
  Report = 'Report',
  Theme = 'Theme',

  SituFacade = 'SituFacade',
  SituView = 'SituView',
  SituPlan = 'SituPlan',
  SituRender = 'SituRender',
  SituFurnish = 'SituFurnish',
  SituVr = 'SituVr',
  SituConnect = 'SituConnect',
  SituVanity = 'SituVanity',
  
}
